export const parseTimeuuid = (gpsFilePath = '') => {
	return gpsFilePath.split('/')[0];
}

export const parseGpsReadingsFileName = (gpsFilePath = '') => {
	return gpsFilePath.split('/').at(-1);
}

export const parseOriginalFileName = (gpsFilePath = '') => {
	const gpsReadingsFileName = parseGpsReadingsFileName(gpsFilePath);
	return gpsReadingsFileName.split('_gpsReadings.')[0];
}

const UTIL_PARSE_GPS_FILE_PATH = {
	parseTimeuuid,
	parseGpsReadingsFileName,
	parseOriginalFileName,
}

export default UTIL_PARSE_GPS_FILE_PATH;

